// components/NextStepRenderer/NextStepRenderer.tsx
import React from "react";
import styles from "./NextActionRenderer.module.css";
import {
  getCchFailureLabel,
  getCchCreationFailureTooltip,
  hasCchCreationFailure,
} from "../../ClientsGrid.utils";

interface Props {
  data: any;
  // wire only what you have today:
  onSendClientApproval?: (row: any) => void;
  onOpenELWizard?: (row: any) => void;
  goToEL?: (row: any) => void;
  goToApproval?: (row: any) => void;
}

const NextStepRenderer: React.FC<Props> = (p) => {
  const hasFailure = hasCchCreationFailure(p.data);
  const rowNext = p.data?.NextAction ?? { label: "No action", tone: "muted" };
  const next = hasFailure
    ? { label: getCchFailureLabel(p.data), tone: "muted" }
    : rowNext;

  const onClick =
    hasFailure
      ? undefined
      : next.label.startsWith("Send for approval")
      ? () => p.onSendClientApproval?.(p.data)
      : next.label.startsWith("Create an EL")
      ? () => p.onOpenELWizard?.(p.data)
      : next.label.startsWith("Go to EL")
      ? () => p.goToEL?.(p.data)
      : next.label.startsWith("Approve client")
      ? () => p.goToApproval?.(p.data)
      : undefined;

  const toneClass =
    next.tone === "success" ? styles.pillSuccess :
    next.tone === "warning" ? styles.pillWarning :
    next.tone === "danger"  ? styles.pillDanger  :
    next.tone === "info"    ? styles.pillInfo    :
                              styles.pillMuted;

  return (
    <div className={styles.wrap}>
      {hasFailure ? (
        <span
          className={`${styles.pill} ${styles.pillFailureMuted}`}
          title={getCchCreationFailureTooltip(p.data)}
          aria-label={getCchCreationFailureTooltip(p.data)}
        >
          {next.label}
        </span>
      ) : (
        <button
          className={`${styles.pill} ${toneClass}`}
          type="button"
          disabled={!onClick}
          onClick={onClick}
          title={next.label}
        >
          {next.label}
        </button>
      )}
    </div>
  );
};

export default NextStepRenderer;
